import { render } from "./Cybersecurity.vue?vue&type=template&id=49ff4a0e"
import script from "./Cybersecurity.vue?vue&type=script&lang=js"
export * from "./Cybersecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__